import type { ContactItemType } from '../../templates';

export const canStart = (c: ContactItemType) => {
  return (
    !c.latest_contact_state || c.latest_contact_state === 'OUTREACH_FAILED'
  );
};
